import React, { Fragment } from 'react';
import '../loggedOut.css';

const AccessibleEats = () => {
   return (
    <Fragment>
        <div className="logged-out">
            <section className="service-hero scene scene--hero page-hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-copy">
                            <h1 className="display-5 mb-3">Accessible Eats</h1>
                            <p className="lead">
                                Designed and delivered by a qualified chef and nutritionist, this program provides a supportive and inclusive cooking environment for participants of all abilities and energy levels.
                            </p>
                        </div>
                        <div className="hero-media text-center">
                            <div className="image-shell image-shell--hero">
                                <img
                                    src="/marketing_images/accessible_eats/1.jpg"
                                    alt="Accessible Eats cooking program"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-content scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <p className="mb-4">
                            Sessions focus on whole foods and a variety of vegetables and protein sources, taught using flexible, choice-based methods. There is no single "correct" way to prepare a meal; participants are supported to cook in ways that suit their individual needs, preferences, and goals.
                        </p>

                        <div className="row align-items-center my-5">
                            <div className="col-md-6 mb-4 mb-md-0">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/accessible_eats/2.jpg"
                                        alt="Step-by-step cooking support"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    Participants receive step-by-step guidance to build practical, transferable cooking skills and are provided with clear, written recipes to support continued use at home. The program encourages creativity, problem-solving, and autonomy, allowing each dish to be adapted to suit the participant.
                                </p>
                            </div>
                        </div>

                        <p className="mb-0">
                            Gentle, non-judgemental support is offered for picky eating, sensory sensitivities, and dietary requirements, with simple ingredient substitutions available. Participants are encouraged to work at their own pace, take breaks as required, and engage in a way that feels safe and manageable for them.
                        </p>
                    </div>
                </div>
            </section>

            <section className="service-footer scene scene--soft py-6">
                <div className="container text-center">
                    <div className="image-shell image-shell--wide">
                        <img
                            src="/marketing_images/accessible_eats/3.jpg"
                            alt="Finished meal from Accessible Eats program"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
);

}

export default AccessibleEats;
